import {
  UserProfile,
  UserProfileArgs,
  getUserProfile,
} from '../assets/ts/data/user-profile'
import useServerData from './use-server-data'

function useUserProfile(fetchArgs?, waitOnParentDependency = false) {
  const {
    data: userProfile,
    error: userProfileError,
    fetchData: fetchUserProfile,
    isLoading: userProfileIsLoading,
  } = useServerData<UserProfile, UserProfileArgs>(
    getUserProfile,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    fetchUserProfile,
    userProfile,
    userProfileError,
    userProfileIsLoading,
  }
}

export default useUserProfile
